import { render, staticRenderFns } from "./CompetitionArchive.vue?vue&type=template&id=0730b7b4&scoped=true"
import script from "./CompetitionArchive.vue?vue&type=script&lang=js"
export * from "./CompetitionArchive.vue?vue&type=script&lang=js"
import style0 from "./CompetitionArchive.vue?vue&type=style&index=0&id=0730b7b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0730b7b4",
  null
  
)

export default component.exports